import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import {Button} from "react-bootstrap";
import { useTranslation } from 'react-i18next';
/**
 * Renders a button which, when selected, will open a popup for login
 */
const alignRight = {
    marginLeft: 'auto'
}
export const SignInButton = () => {
    var { instance } = useMsal();
    const { t } = useTranslation();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }

    return (
        <Button variant="secondary" style={alignRight} onClick={() => handleLogin("popup")}>{t("create_signtask_nav_login")}</Button>
    );
}